var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const getParsedTree = (_context_1, _a) => __awaiter(void 0, [_context_1, _a], void 0, function* (_context, { colOptions, }) {
    if (!colOptions) {
        return undefined;
    }
    if ('getParsedTree' in colOptions) {
        return colOptions.getParsedTree();
    }
    else {
        return colOptions.parsed_tree;
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0UGFyc2VkVHJlZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvdW5pZmllZE1ldGEvZ2V0UGFyc2VkVHJlZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFHQSxNQUFNLENBQUMsTUFBTSxhQUFhLEdBQUcsaUJBUTNCLEVBQUUsd0RBUEYsUUFBbUIsRUFDbkIsRUFDRSxVQUFVLEdBSVg7SUFFRCxJQUFJLENBQUMsVUFBVSxFQUFFLENBQUM7UUFDaEIsT0FBTyxTQUFTLENBQUM7SUFDbkIsQ0FBQztJQUNELElBQUksZUFBZSxJQUFJLFVBQVUsRUFBRSxDQUFDO1FBQ2xDLE9BQU8sVUFBVSxDQUFDLGFBQWEsRUFBRSxDQUFDO0lBQ3BDLENBQUM7U0FBTSxDQUFDO1FBQ04sT0FBTyxVQUFVLENBQUMsV0FBVyxDQUFDO0lBQ2hDLENBQUM7QUFDSCxDQUFDLENBQUEsQ0FBQyJ9